export function createSupplierLibraryApi({ getAccessToken, fetchImpl = globalThis.fetch } = {}) {
  const salesCache=new Map(),batchCache=new Map();
  async function request(query, { signal } = {}) {
    const token = await getAccessToken();
    if (!token) throw new Error('Please sign in again.');
    const response = await fetchImpl(`/api/supplier-orders/library?${query}`, { headers: { Authorization: `Bearer ${token}` }, cache: 'no-store', ...(signal ? { signal } : {}) });
    if (!response.ok) throw new Error(response.status === 401 ? 'Please sign in again.' : response.status === 403 ? 'This page is available to authorised staff.' : 'Could not load cards. Please try again.');
    return response.json();
  }
  return {
    batchSales:true,
    async list({ search = '', supplier = '', set = '', year = '', offset = 0, priceBasis = 'latest', minPrice = '', maxPrice = '', finish = '', sort = 'recent' } = {}) {
      const query = new URLSearchParams({ search, supplier, offset: String(offset) });
      if (set) query.set('set', set);
      if (year) query.set('year', year);
      if (minPrice !== '') query.set('min_price', minPrice);
      if (maxPrice !== '') query.set('max_price', maxPrice);
      if (minPrice !== '' || maxPrice !== '' || sort.startsWith('price_')) query.set('price_basis', priceBasis);
      if (finish) query.set('finish', finish);
      if (sort !== 'recent') query.set('sort', sort);
      const data = await request(query);
      if (!Array.isArray(data?.cards) || !Number.isSafeInteger(data.total) || data.total < data.cards.length || data.offset !== offset) throw new Error('The card list could not be confirmed.');
      return data;
    },
    async facets() {
      const data = await request(new URLSearchParams({ facets: '1' }));
      if (!Array.isArray(data?.sets)) throw new Error('Set filters could not be loaded.');
      return data.sets;
    },
    async history(id) {
      if (!/^[1-9][0-9]{0,14}$/.test(String(id))) throw new Error('Select a card again.');
      const data = await request(new URLSearchParams({ id: String(id) }));
      if (!Array.isArray(data?.history) || !Number.isSafeInteger(data.total) || data.total < data.history.length) throw new Error('The purchase history could not be confirmed.');
      return data;
    },
    async sales(id) {
      if (!/^[1-9][0-9]{0,14}$/.test(String(id))) throw new Error('Select a card again.');
      if(!await getAccessToken())throw new Error('Please sign in again.');
      const saved=salesCache.get(String(id));if(saved&&Date.now()-saved.at<30000)return saved.data;
      const data = await request(new URLSearchParams({ sales: String(id) }));
      if (!Array.isArray(data?.sales)) throw new Error('Recorded sales could not be confirmed.');
      salesCache.set(String(id),{at:Date.now(),data});while(salesCache.size>24)salesCache.delete(salesCache.keys().next().value);
      return data;
    },
    async saleBatch(id,grade='10'){
      if(!await getAccessToken())throw new Error('Please sign in again.');
      const key=`${id}:${grade}`,saved=batchCache.get(key);if(saved&&Date.now()-saved.at<30000)return saved.data;
      const data=await request(new URLSearchParams({sales:String(id),batch:'1',grade}));if(!Array.isArray(data?.sales))throw new Error('Sale batch unavailable.');
      batchCache.set(key,{at:Date.now(),data});while(batchCache.size>48)batchCache.delete(batchCache.keys().next().value);return data;
    },
    async performance({days=90,grade='10',seller='',refresh=false}={}){
      const query=new URLSearchParams({performance:'1',days:String(days),grade,seller});if(refresh)query.set('refresh','1');
      const data=await request(query);if(data.restricted)return data;
      if(data?.version!=='cardcam-performance/v1'||!Array.isArray(data.rows)||!data.totals||!['sales','pricedSales','cards'].every(k=>Number.isSafeInteger(data.totals[k])&&data.totals[k]>=0)||data.rows.some(row=>typeof row.key!=='string'||typeof row.name!=='string'||!Number.isSafeInteger(row.sales)||row.sales<1||!Number.isSafeInteger(row.pricedSales)||row.pricedSales<0||!['costCoveragePercent','averageHammerGBP'].every(k=>typeof row[k]==='number'&&Number.isFinite(row[k])))||!Number.isFinite(Date.parse(data.checkedAt)))throw new Error('Performance evidence could not be confirmed.');return data;
    },
    async saleDetails(id, sale, { signal } = {}) {
      salesCache.delete(String(id));batchCache.delete(`${id}:10`);batchCache.delete(`${id}:9`);
      if (!/^[1-9][0-9]{0,14}$/.test(String(id)) || !/^[0-9a-f-]{36}$/i.test(sale?.capture_id || '') || !/^[a-f0-9]{64}$/.test(sale?.merchandise_key || '')) throw new Error('Open this card again to check its sale.');
      const data = await request(new URLSearchParams({ sales: String(id), capture: sale.capture_id, group: sale.merchandise_key }), { signal });
      if (data?.sale?.captureID !== sale.capture_id || data.sale.certificateNumber !== sale.certification_number || !['verified','conflict','unavailable'].includes(data.sale.identityStatus)) throw new Error('The sale verification could not be confirmed.');
      return data.sale;
    },
  };
}
